module.exports = __webpack_public_path__ + "media/img/pages/companies/hotelleriesuisse-6dc91bee96259330d8278b5943bda15e.png";